<template>
  <cube-card-list :value="handleExpanded_">
    <div class="cube-multi-search">
      <cube-card  :name="cardName" body-padding="left,bottom" :hide-buttons="false">
        <template slot="title">
          <div class="cube-multi-search-title">已选项</div>
        </template>
        <template slot="title-right">
          <div class="scroll-tag" :style="tagWidth">
            <search-tag-group :option="{label:'labelKey'}" :list="handleTagList_" @onClose="closeTag"/>
          </div>
        </template>
        <template slot="header-right">
          <div class="flexC select-right">
            <div v-if="total || total === 0" class="mr-8">
              <span class="cube-multi-search-total">
                共<span class="color">{{ total }}</span
                >条
              </span>
            </div>
            <cube-button v-if="clearable" type="secondary" @click="clear">
              {{ clearBtnText }}</cube-button>
            <cube-button type="primary" @click="save"> {{ saveBtnText }}</cube-button>
          </div>
        </template>
        <template slot="default">
          <div
            v-for="(item, index) in list_"
            :key="index"
            :class="itemClass_(index)"
          >
            <div class="cube-multi-search-item__label pb-6">
              {{ item.label }}
            </div>
            <div class="cube-multi-search-item__option flexC">
              <template v-if="item.type === 'checkbox'">
                <cube-checkbox-group
                  v-model="query[item.key]"
                  class="mr-8"
                  :disabled="item.disabled"
                >
                  <cube-checkbox
                    v-for="(child, childIndex) in item.children"
                    :key="childIndex"
                    :label="child.value"
                    :disabled="item.disabled"
                    class="pb-6"
                    @change="(value) => changeCheckbox(value, child, item)"
                  >
                    <spann class="text">
                      {{ child.label }}
                    </spann>
                  </cube-checkbox>
                  <template v-if="item.moreBtn && item.type === 'checkbox'">
                    <cube-button
                      class="ml-8 mb-6"
                      plain
                      @click="toggleMore(item)"
                    >
                      {{ item.show ? '收起' : '更多' }}</cube-button
                    >
                  </template>
                </cube-checkbox-group>
              </template>
              <template v-if="item.type === 'tag'">
                <div
                  v-for="(child, childIndex) in item.children"
                  :key="child.value + childIndex"
                  :class="['tag', 'flexC', 'mb-6', handleTagActive_(item, child)]"
                  @click="clickTag(child, item)"
                >
                  {{ child.label }}
                </div>
              </template>
              <template v-if="item.type === 'img'">
                <img
                  v-for="(child, childIndex) in item.children"
                  :key="child.value + childIndex"
                  :src="child.src"
                  :class="['img', 'mb-6', handleImgActive_(item, child)]"
                  @click="clickImg(child, item)"
                />
              </template>
              <!-- <template v-if="item.addOption">
                  <add-option-dialog :parent="item" @confirm="operateConfirm" />
                </template> -->
              <template v-if="item.type === 'search'">
                <search
                  :ref="item.key"
                  class="pb-6"
                  :parent="item"
                  :default-select="defaultSelect"
                  @clear="(type) => clearOption(type, item)"
                  @confirm="operateConfirm"
                />
              </template>
              <template v-if="item.type === 'datePick'">
                <date
                  :ref="item.key"
                  class="pb-6"
                  :parent="item"
                  @clear="(type) => clearOption(type, item)"
                  @confirm="operateConfirm"
                ></date>
              </template>
              <template v-if="item.type === 'input'">
                <multil-input
                  :ref="item.key"
                  class="pb-6"
                  :parent="item"
                  @clear="(type) => clearOption(type, item)"
                  @confirm="operateConfirm"
                ></multil-input>
              </template>
              <!-- 额外的option -->
              <template v-if="item.moreBtn && item.type !== 'checkbox'">
                <cube-button class="mr-8 mb-6" plain @click="toggleMore(item)">
                  {{ item.show ? '收起' : '更多' }}</cube-button
                >
              </template>
              <template v-if="item.range">
                <range class="mb-6" :parent="item" @confirm="operateConfirm" />
              </template>
              <!-- <tmeplate v-if="item.searchConfig">
                <search :parent="item" @confirm="operateConfirm" />
              </tmeplate> -->
            </div>
          </div>
        </template>
      </cube-card>
    </div>
  </cube-card-list>
</template>
<script>
// import addOptionDialog from './components/addoption.vue'
import range from './components/range.vue'
import search from './components/search.vue'
import date from './components/date.vue'
import multilInput from './components/input.vue'
import SearchTagGroup from '../../SearchTagGroup/src/index.vue'
import '../../../../lib/styles/components/MultiSearch.scss'
export default {
  name: 'MultiSearchGroup', // MultiSearch
  components: {
    // addOptionDialog,
    range,
    search,
    date,
    multilInput,
    SearchTagGroup
  },
  props: {
    expanded: {
      type: Boolean,
      default: true
    },
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    clearable: {
      type: Boolean,
      default: true
    },
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    defaultOptionLength: {
      type: [Number, String],
      default: 10
    },
    total: {
      type: [Number, String],
      default: null
    },
    defaultSelect: {
      type: String,
      default: 'otter-select'
    },
    clearBtnText: {
      type: String,
      default: '清空已选'
    },
    saveBtnText: {
      type: String,
      default: '保存参数'
    }
  },
  data() {
    return {
      // 已选项的数据 {key: 大类，value[]小类value}
      query: {},
      tagList: [],
      keyMap: new Map(),
      valueMap: new Map(),
      list_: [],
      cardName: 'cube-multi-search'
    }
  },
  computed: {
    handleExpanded_() {
      return this.expanded ? [this.cardName] : []
    },
    itemClass_() {
      return (index) => {
        const res = index !== this.list_.length - 1 ? 'border-bottom' : ''
        return `${res} cube-multi-search-item flexC`
      }
    },
    handleTagActive_() {
      return (item, child) => {
        const params = this.query[item.key]
        return params.includes(child.value) ? 'tag__active' : ''
      }
    },
    handleImgActive_() {
      return (item, child) => {
        const params = this.query[item.key]
        return params.includes(child.value) ? 'img__active' : ''
      }
    },
    handleDate_() {
      return (value) => {
        if (typeof value === 'string') {
          return value
        }
        if (Array.isArray(value)) {
          return `${value[0]} - ${value[1]}`
        }
        return value
      }
    },
    handleTagList_() {
      return this.tagList.map(tag => {
        const pre = `${tag.title}`
        const sub = tag.type === 'datePick' ? this.handleDate_(tag.value) : tag.label
        return {
          labelKey: `${pre}：${sub}`,
          ...tag
        }
      })
    }
  },
  watch: {
    query: {
      handler(nv) {
        this.$emit('change', nv)
        this.$emit('input', nv)
      },
      deep: true
    },
    total: {
      handler() {
        this.$nextTick(() => {
          this.watchTotalChange()
        })
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.resetStyle()
    })
  },
  created() {
    this.collectData()
  },
  methods: {
    normalizeParams() {
      const params = Object.assign({}, this.query)
      for (const i in params) {
        const values = params[i]
        const equal1 = values.length === 1
        if (equal1) {
          params[i] = params[i][0]
        }
      }
      return params
    },
    handQueryWithType(key, value) {
      const qeuryType = typeof this.query[key]
      if (qeuryType === 'string') {
        this.query[key] = ''
      } else if (Array.isArray(this.query[key])) {
        const arr = this.query[key]
        for (let i = this.query[key].length - 1; i >= 0; i--) {
          const item = this.query[key][i]
          if (item === value) {
            arr.splice(i, 1)
          } else if (Array.isArray(value)) {
            if (value.includes(item)) {
              arr.splice(i, 1)
            }
          }
        }
      }
    },
    // 关闭已选项标签
    closeTag({ value: tag, index: i }) {
      const { key, type, value } = tag
      if (type === 'datePick' || type === 'input' || type === 'search') {
        this.$refs[key][0].reset()
      }
      this.handQueryWithType(key, value)
      this.tagList.splice(i, 1)
      this.$emit('delete-selected', tag)
    },
    // findRangeTag(item) {
    //   const rangeLevel = item.rangeLevel === 0 ? item.rangeLevel : 1
    //   if (rangeLevel === 1) {
    //     return false
    //   }
    //   let disabled = false
    //   const { key } = item
    //   this.tagList.forEach(tag => {
    //     if (tag.key === key && tag.type === 'range') {
    //         disabled = true
    //     }
    //   })
    //   return disabled
    // },
    // 点击备选项图像
    clickImg(child, item) {
      const { key } = item
      const { value, disabled } = child
      if (disabled) return
      if (!child.selected) {
        this.handleSingleSelection(item, 'multiple')
        this.query[key].push(value)
        this.pushTag(child, item)
        this.$set(child, 'selected', true)
      } else {
        this.deleteTag(child, item)
        this.$set(child, 'selected', false)
      }
      this.$emit('select', item, child)
    },
    // 点击备选项标签
    clickTag(child, item) {
      const { key } = item
      const { value, disabled } = child
      if (disabled) return
      if (!child.selected) {
        this.handleSingleSelection(item)
        this.query[key].push(value)
        this.pushTag(child, item)
        this.$set(child, 'selected', true)
      } else {
        this.deleteTag(child, item)
        this.$set(child, 'selected', false)
      }
      this.$emit('select', item, child)
    },
    handleSingleSelection(item, defaultSelection = 'single') {
      const selection = item.selection ? item.selection : defaultSelection
      if (selection === 'single') {
        const filterSelected = item.children.filter((item) => {
          return item.selected
        })
        const f = filterSelected[0]
        if (f) {
          this.deleteTag(f, item)
          this.$set(f, 'selected', false)
        }
      }
    },
    // checkbox更新操作
    changeCheckbox(check, child, item) {
      // if (this.findRangeTag(item)) {
      //   return
      // }
      const selection = item.selection ? item.selection : 'multiple'
      const operate = check ? 'pushTag' : 'deleteTag'
      check && this.handleSingleSelection(item, selection)
      this.$set(child, 'selected', check)
      this[operate](child, item)
    },
    // 切换展示更多内容
    toggleMore(item) {
      this.$set(item, 'show', !item.show)
      if (item.show) {
        this.$set(item, 'children', item.totalItem)
      } else {
        this.$set(
          item,
          'children',
          item.totalItem.slice(0, item.defaultOptionLength)
        )
        this.$set(item, 'more', item.totalItem.slice(item.defaultOptionLength))
      }
    },
    clearOption(type, item) {
      const { key } = item
      this.tagList.forEach((item, index, arr) => {
        if (item.key === key) {
          arr.splice(index, 1)
        }
      })
      if (type === 'datePick') {
        this.query[key] = []
      }
      if (type === 'search' || type === 'input') {
        this.query[key] = ''
      }
    },
    // 额外选项确认操作
    operateConfirm(parent, tag, type) {
      const { key } = parent
      // type 参数 range 添加最大值最小值选项到已选项 search 添加搜索选项到已选项
      // if (type === 'range' || type === 'search') {}
      // if (type === 'range') {
      //   const rangeLevel = parent.rangeLevel ===0 ? parent.rangeLevel  :1
      //   if (rangeLevel === 0) {
      //     const { key } = parent
      //     if (this.query[key]) {
      //       this.$set(this.query, key, [])
      //       this.tagList.forEach((item,index,arr) => {
      //         if (item.key === key)  {
      //           arr.splice(index, 1)
      //             console.log(
      //               1
      //             )
      //         }
      //       })
      //     }
      //   }
      // }
      if (type === 'datePick' || type === 'search' || type === 'input') {
        this.query[key] = tag.value
        this.replaceTag(tag, parent, type)
      } else {
        this.query[key].push(tag.value)
        this.pushTag(tag, parent, type)
      }
      // addOption 添加选项到备选栏
      // if (type === 'addOption') {
      //   const list = parent.children
      //   for (let i = 0; i < list.length; i++) {
      //     if (tag.value === list[i].value) {
      //       console.error(`${parent.label}项的子选项属性值重复，重复属性值为${tag.value}，标签名为${list[i].label}`)
      //       break
      //     }
      //   }
      //   parent.children.push(tag)
      //   this.$emit('add-option', parent, tag)
      // }
    },
    // 处理单选的情况

    replaceTag(child, parent, type) {
      let isFind = false
      this.tagList.forEach((item, index, arr) => {
        if (item.key === parent.key) {
          isFind = true
          const { label, value } = child
          const { label: title, key } = parent
          const tag = {
            label,
            value,
            title,
            key,
            type
          }
          arr.splice(index, 1, tag)
        }
      })
      if (!isFind) {
        this.pushTag(child, parent, type)
      }
    },
    // 添加标签以及query数据
    pushTag(child, parent, type) {
      const { label, value } = child
      const { label: title, key } = parent
      const tag = {
        label,
        value,
        title,
        key,
        type
      }
      this.tagList.push(tag)
      this.$emit('select', child, parent)
    },
    // 删除标签 同时删除query数据
    deleteTag(child, parent) {
      const { key } = parent
      const { value } = child
      this.handQueryWithType(key, value)
      this.tagList.forEach((i, index, arr) => {
        const { label, value } = i
        const { label: cLabel, value: cValue } = child
        const condition = value === cValue && cLabel === label
        if (condition) {
          arr.splice(index, 1)
        }
      })
      this.tagList = [...this.tagList]
      this.$emit('delete-selected', child, parent)
    },
    // 收集数据 创建回显列表
    collectData(type = 'init') {
      if (type === 'init') {
        const backup = Array.from(this.list)
        this.$set(this, 'list_', backup)
      }
      // 收集数据以方便映射
      const res = {}
      this.list_.map((item) => {
        res[item.key] = []
        this.keyMap.set(item.key, item.label)
        if (item.children) {
          this.$set(item, 'totalItem', item.children)
          item.children.map((child) => {
            this.valueMap.set(child.value, child.label)
          })
        }
        if (type === 'init') {
          item.defaultOptionLength = item.defaultOptionLength
            ? item.defaultOptionLength
            : this.defaultOptionLength
          if (
            item.children &&
            item.children.length > item.defaultOptionLength
          ) {
            this.$set(item, 'moreBtn', true)
            this.$set(
              item,
              'more',
              item.totalItem.slice(item.defaultOptionLength)
            )
            this.$set(
              item,
              'children',
              item.totalItem.slice(0, item.defaultOptionLength)
            )
            this.$set(item, 'show', false)
          }
        }
      })
      this.$set(this, 'query', res)
    },
    clear() {
      this.collectData('clear')
      this.list.forEach(item => {
        if (item.type === 'input' || item.type === 'search' || item.type === 'datePick') {
          const ref = this.$refs[item.key]
          if (Array.isArray(ref)) {
            ref.forEach(i => {
              i.reset()
            })
          } else {
            ref && ref.reset()
          }
        }
      })
      this.tagList = []
      this.$emit('clear')
    },
    save() {
      this.$emit('save', this.query)
    },
    resetStyle() {
      // 统一label宽度
      this.$el.querySelector('.slot-buttons').style.position = 'relative'
      const labels = this.$el.querySelectorAll('.cube-multi-search-item__label')
      let max = 0
      Array.from(labels).forEach((item) => {
        if (max < item.clientWidth) {
          max = item.clientWidth
        }
      })
      Array.from(labels).forEach((item) => {
        item.style.minWidth = `${max}px`
      })
    },
    watchTotalChange() {
      // 计算出中间tag的宽度
      const right = this.$el.querySelector('.select-right')
      const title = this.$el.querySelector('.cube-card-header__title .title')
      const total = this.$el.querySelector('.cube-card-header')
      const style = window.getComputedStyle(total)
      const pl = parseFloat(style.getPropertyValue('padding-left'))
      const pr = parseFloat(style.getPropertyValue('padding-right'))
      const totalW = parseFloat(style.getPropertyValue('width'))
      const contentWidth = Number(totalW - pl - pr)
      const res = contentWidth - right.clientWidth - title.clientWidth - 50
      this.$el.querySelector('.scroll-tag').style.width = `${res}px`
    }
  }
}
</script>
